import { setShowListPane, setShowReadingPane } from 'owa-mail-layout';
import { action } from 'satcheljs/lib/legacy';
import { isReadingPanePositionOff } from 'owa-mail-layout/lib/selectors/readingPanePosition';

/**
 * Close the list pane and show the reading pane based on the user configuration
 */
export default action('onSelectMessageAd')(function onSelectMessageAd() {
    setShowReadingPane(true); /* showReadingPane */
    setShowListPane(!isReadingPanePositionOff() /* showListPane */);
});
